module.exports = __webpack_public_path__ + "img/Wp_2080.fb9a41b6.png";